import {post} from './RequestUtil'
import vue from '../main'

export const MilkRequestUtil = {
  queryGoodsList (params, callback) {
    post('/milk/goods/list', params).then((response) => {
      callback && callback(response)
    })
  },
  saveGoodsInfo (params, callback) {
    post('/milk/goods/save', params).then((response) => {
      callback && callback(response)
    })
  },
  upGoods (params, callback) {
    post('/milk/goods/up', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  downGoods (params, callback) {
    post('/milk/goods/down', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  removeGoods (params, callback) {
    post('/milk/goods/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  querySchoolList (params, callback) {
    post('/milk/school/list', params).then((response) => {
      callback && callback(response)
    })
  },
  saveSchoolInfo (params, callback) {
    post('/milk/school/save', params).then((response) => {
      callback && callback(response)
    })
  },
  activeSchool (params, callback) {
    post('/milk/school/active', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  invalidSchool (params, callback) {
    post('/milk/school/invalid', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  removeSchool (params, callback) {
    post('/milk/school/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  queryOrderList (params, callback) {
    post('/milk/order/list', params).then((response) => {
      callback && callback(response)
    })
  },
  queryOrderLog (params, callback) {
    post('/milk/order/log', params).then((response) => {
      callback && callback(response)
    })
  },
  queryOrderDetail (params, callback) {
    post('/milk/order/info', params).then((response) => {
      callback && callback(response)
    })
  },
  closeOrder (params, callback) {
    post('/milk/order/close', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  removeOrder (params, callback) {
    post('/milk/order/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  removeOrderGoods (params, callback) {
    post('/milk/order/goods/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  updateOrderGoods (params, callback) {
    post('/milk/order/goods/update', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  queryArea (params, callback) {
    post('/area/list', params).then((response) => {
      callback && callback(response)
    })
  },
  queryCategoryList (params, callback) {
    post('/milk/category/list', params).then((response) => {
      callback && callback(response)
    })
  },
  updateCategorySort (params, callback) {
    post('/milk/category/sort', params).then((response) => {
      callback && callback(response)
    })
  },
  removeCategory (params, callback) {
    post('/milk/category/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  saveCategory (params, callback) {
    post('/milk/category/save', params).then((response) => {
      callback && callback(response)
    })
  },
  queryMemberList (params, callback) {
    post('/milk/member/list', params).then((response) => {
      callback && callback(response)
    })
  },
  passMember (params, callback) {
    post('/milk/member/pass', params).then((response) => {
      callback && callback(response)
    })
  },
  refuseMember (params, callback) {
    post('/milk/member/refuse', params).then((response) => {
      callback && callback(response)
    })
  },
  removeMember (params, callback) {
    post('/milk/member/remove', params).then((response) => {
      callback && callback(response)
    })
  },
  queryAreaList (params, callback) {
    post('/milk/area/list', params).then((response) => {
      callback && callback(response)
    })
  },
  saveArea (params, callback) {
    post('/milk/area/save', params).then((response) => {
      callback && callback(response)
    })
  },
  removeArea (params, callback) {
    post('/milk/area/remove', params).then((response) => {
      callback && callback(response)
    })
  },
  queryDepartmentList (params, callback) {
    post('/milk/department/list', params).then((response) => {
      callback && callback(response)
    })
  },
  saveDepartment (params, callback) {
    post('/milk/department/save', params).then((response) => {
      callback && callback(response)
    })
  },
  removeDepartment (params, callback) {
    post('/milk/department/remove', params).then((response) => {
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/MilkRequestUtil.js